// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2ntf_","colMin":"styles_colMin__3PpEa","colCheckbox":"styles_colCheckbox__1fbkC"};